module.exports = __webpack_public_path__ + "static/media/message.84ead971.png";